// extracted by mini-css-extract-plugin
export default {"form":"vp_nbxbs","shell":"vp_rXcKr","input":"vp_VfgtW"};